// Numeric limit fields for the Organization details form.
// `name` must match the react-hook-form field / API payload key exactly.

export const ORGANIZATION_LIMITS = [
  { name: 'maxPrinterModels', label: 'Max Printer Models', icon: 'fas fa-print' },
  { name: 'maxLabels', label: 'Max Labels', icon: 'fas fa-tags' },
  { name: 'maxUsers', label: 'Max Users', icon: 'fas fa-users' },
  { name: 'maxWidgets', label: 'Max Widgets', icon: 'fas fa-puzzle-piece' },
  { name: 'maxPCLPrinters', label: 'Max PCL Printers', icon: 'fas fa-file-code' },
  { name: 'maxAgents', label: 'Max Agents', icon: 'fas fa-robot' },
];

export const ORGANIZATION_LIMIT_NAMES = ORGANIZATION_LIMITS.map((l) => l.name);
